import {
  call,
  fork,
  put,
  putResolve,
  select,
  take,
  delay
} from 'redux-saga/effects'
import { getFormSelector } from 'ddiForm/utils'
import { getIn, is } from 'utils'
import { resetMasterFields } from 'ddiForm/MasterScreen/actions'
import { displayValidationErrors } from 'ddiForm/sagas'

import { confirmationModal, warningModal } from 'modals/sagas'
import { addModal, confirm, canceled, removeModal } from 'modals/actions'
import { CANCELED, CONFIRMED } from 'modals/constants'

import SerialNumberEditorModal from '../components/SerialNumberEditorModal'
import * as CONSTANTS from '../constants'
import * as actions from '../actions'
import { validateSalesOrderProcess } from '.'
import {
  changeGridItem as changeGridItemAPI,
  validateSalesOrder as validateSalesOrderAPI
} from '../api'

export function* openSerialNumberEditor(form, data = {}, initialRequestParams) {
  const isMobile = yield select(state => getIn(state, 'mobile.isMobile')) ||
    false

  yield put(actions.destroySerialNumberFields(form))

  const isLotsEditor =
    data?.lotSearchType ||
    data?.data?.lotSearchType ||
    (data?.message &&
      typeof data?.message === 'string' &&
      data?.message?.match(/Lot Input Required/)) ||
    false

  // debugger
  const modalOpts = {
    component: SerialNumberEditorModal,
    options: {
      actions: false,
      title: isLotsEditor ? 'Lot Review' : 'Serial Number Review',
      data: {
        form,
        initialRequestParams,
        isMobile,
        lineHeaderDisplay: data?.lineHeaderDisplay,
        ...data?.data
      },
      fullScreen: true,
      marginTop: '0px',
      maxHeight: '95%',
      width: '95%',
      maxWidth: '95%'
    }
  }

  const modal = yield call(addModal, form, modalOpts)
  yield put(modal)

  return modal.payload.id
}

export function* modifyLineItemSerialNumberProcess(
  form,
  apiParams = {},
  rowId,
  thunk
) {
  const formState = yield select(getFormSelector(form))
  const guid = getIn(formState, 'guid')

  const groupNames = ['header', 'detail']

  yield put(actions.modifyLineItemSerialNumber.request(form))

  const { response, error } = yield call(changeGridItemAPI, {
    guid,
    groupNames,
    gridName: 'lineItems',
    ...apiParams
  })

  if (response) {
    yield put({
      type: CONSTANTS.MODIFY_LINE_ITEM_SERIAL_NUMBER.SUCCESS,
      meta: {
        form,
        thunk
      },
      payload: {
        ...response,
        activeLineNumber: apiParams?.lineNumber,
        activeRowId: rowId
      }
    })
    const { messages, ...rest } = response
    yield put(
      actions.onPropertyChange.success(
        {
          propertyChanged: 'bins',
          ...response,
          ...rest
        },
        {
          form
        }
      )
    )
    if (messages && Array.isArray(messages)) {
      for (const msg of messages) {
        yield call(warningModal, msg.message, msg.title)
      }
    }
  } else {
    debugger
    yield put({
      type: CONSTANTS.MODIFY_LINE_ITEM_SERIAL_NUMBER.FAILURE,
      meta: {
        form,
        thunk
      },
      payload:
        error?.status === 496
          ? {
              propertyChanged: 'bins'
            }
          : {
              ...error,
              propertyChanged: 'bins'
            }
    })

    yield fork(displayValidationErrors, error)
  }
}

export function* modifyLineItemSerialNumberListener(formListener) {
  while (true) {
    const {
      meta: { form, thunk },
      payload: { apiParams = {}, rowId }
    } = yield take(CONSTANTS.MODIFY_LINE_ITEM_SERIAL_NUMBER.TRY)

    if (form === formListener) {
      yield fork(
        modifyLineItemSerialNumberProcess,
        form,
        apiParams,
        rowId,
        thunk
      )
    }
  }
}

export function* handleSerialNumberReviewChangeProcess(
  form,
  thunk,
  apiParams = {},
  modalId
) {
  const formState = yield select(getFormSelector(form))
  const guid = getIn(formState, 'guid')
  const dataId = getIn(formState, 'fields.dataId.value')

  yield put(actions.handleSerialNumberReviewChange.request(form))
  const { response, error } = yield call(validateSalesOrderAPI, {
    dataId,
    guid,
    ...apiParams
  })

    if (response) {
    yield put({
      type: CONSTANTS.HANDLE_SERIAL_NUMBER_REVIEW_CHANGE.SUCCESS,
      meta: {
        form,
        thunk
      },
      payload: {
        ...response,
        apiParams
      }
    })

    if (modalId) {
      yield put(removeModal(form, modalId))
      }
  } else {
    yield put({
      type: CONSTANTS.HANDLE_SERIAL_NUMBER_REVIEW_CHANGE.FAILURE,
      meta: {
        form,
        thunk
      },
      payload: {
        ...error
      }
    })
    }

    const messages = error?.data?.messages
    if (messages && Array.isArray(messages)) {
        for (var msg of messages) {
            yield call(warningModal, msg.message, msg.title)
        }
    }
}

export function* confirmSerialNumberReviewSaveAttempt(
  form,
  apiParams,
  modalId,
  initialRequestParams
) {
  const formState = yield select(getFormSelector(form))
  const isIncomplete =
    getIn(formState, 'values.serialNumberIsIncomplete') || false

  if (isIncomplete) {
    yield call(confirmationModal, 'Continue anyway?', 'Incomplete data')

    const action = yield take([CONFIRMED, CANCELED])
    if (action.type === CANCELED) {
      return
    }
  }

  const {
    generateId,
    manualDataIdEntry,
    saveWithoutSignature,
    saveAttemptPayload
  } = initialRequestParams

  if (modalId) {
    yield put(removeModal(form, modalId))
  }

  debugger
  yield fork(
    validateSalesOrderProcess,
    form,
    generateId,
    manualDataIdEntry,
    saveWithoutSignature,
    saveAttemptPayload,
    apiParams
  )
}

export function* handleSerialNumberReviewChangeListener(formListener) {
  while (true) {
    const {
      meta: { form, thunk },
      payload: { apiParams, modalId, initialRequestParams }
    } = yield take(CONSTANTS.HANDLE_SERIAL_NUMBER_REVIEW_CHANGE.TRY)

    if (form === formListener) {
      if (
        initialRequestParams ||
        (apiParams?.action && apiParams?.action === 'commit')
      ) {
        yield fork(
          confirmSerialNumberReviewSaveAttempt,
          form,
          apiParams,
          modalId,
          initialRequestParams
        )
      } else {
        yield fork(
          handleSerialNumberReviewChangeProcess,
          form,
          thunk,
          apiParams,
          modalId
        )
      }
    }
  }
}

export default function* serialNumberSagas(form) {
  yield fork(modifyLineItemSerialNumberListener, form)
  yield fork(handleSerialNumberReviewChangeListener, form)
}
